export const NEXT_PAGE = 'nextPage';
export const RESET = 'reset';
